export function formatDecimal(value) {
    if (value) {
        return value.toFixed(2);
    }
    return "0";
}
export function count(value) {
    if (value) {
        const number = (value / 1).toFixed(0).replace(",", ".");
        return number < 0 ?
            "-" + +number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
            number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "0";
}
export function formatSize(value) {
    const sizes = ["KB", "MB", "GB"];
    if (value === 0) return "0";
    const number = parseInt(Math.floor(Math.log(value) / Math.log(1024)), 10);
    if (number === 0) return `${value} ${sizes[number]}`;
    return `${(value / 1024 ** number).toFixed(1)} ${sizes[number]}`;
}